module.exports = __webpack_public_path__ + "img/d4.cac4eb6b.jpg";